export default {
    title: 'Miejsca',
    count: '{n} miejsce | {n} miejsca | {n} miejsc',
    noList: 'Bez listy',
    dragToReorder: 'Przeciągnij, aby zmienić kolejność',
    saved: 'Zapisane.',
    saveFailed: 'Nie udało się zapisać.',
    removeFailed: 'Nie udało się usunąć.',
    orderFailed: 'Nie udało się zapisać kolejności.',
    navigate: 'Nawiguj',
    edit: 'Edytuj',
    colors: {
        red: 'Czerwony',
        orange: 'Pomarańczowy',
        amber: 'Bursztynowy',
        green: 'Zielony',
        teal: 'Morski',
        blue: 'Niebieski',
        indigo: 'Indygo',
        purple: 'Fioletowy',
        pink: 'Różowy',
        gray: 'Szary',
    },
    location: {
        unsupported: 'Ta przeglądarka nie podaje lokalizacji.',
        denied: 'Brak zgody na lokalizację — włącz ją dla tej strony w przeglądarce.',
        failed: 'Nie udało się ustalić lokalizacji.',
    },
    map: {
        filters: {
            all: 'Wszystkie',
            favorite: 'Ulubione',
        },
        savedFlash: 'Zapisane: „{name}".',
        deletedFlash: 'Usunięte: „{name}".',
        pinnedLimit: 'Przypiętych może być najwyżej {max} — odepnij któreś.',
        pinnedFlash: '„{name}" przypięte.',
        unpinnedFlash: '„{name}" odpięte.',
        linkFailed: 'Z tego linku nie da się odczytać miejsca. Wklej link z „Udostępnij" w Google Maps.',
        pasteHint: 'Skopiuj link z „Udostępnij" w Google Maps i wklej go w pole szukania.',
        addFirst: 'Najpierw dodaj miejsce — potem przypniesz je pinezką.',
        pinHighlightTitle: 'Przypnij',
        pinHighlightText: 'Pinezka przy miejscu przypina je na górę modułu — jedno tapnięcie i rusza nawigacja.',
        pinned: 'PRZYPIĘTE',
        pinnedEmpty: 'Przypnij miejsca, do których jeździsz najczęściej — pojawią się tu z nawigacją jednym tapnięciem.',
        searchPlaceholder: 'Szukaj miejsca albo adresu, albo wklej link z Google Maps',
        searchLabel: 'Szukaj miejsca',
        readingLink: 'Odczytuję link…',
        addFromLink: 'Dodaj miejsce z tego linku',
        yourPlaces: 'TWOJE MIEJSCA',
        onMap: 'NA MAPIE',
        searching: 'Szukam…',
        nothingFound: 'Nic nie znalazłem — spróbuj z miastem albo tapnij w mapę.',
        here: 'Tu jestem',
        pasteLink: 'Wklej link',
        viewLabel: 'Widok',
        viewMap: 'Mapa',
        viewList: 'Lista',
        showMyLocation: 'Pokaż moją lokalizację',
        tapHint: 'Tapnij w mapę, żeby zapisać tam miejsce — albo wyszukaj je wyżej.',
        newHereTitle: 'Nowe miejsce tutaj?',
        newHereText: 'Pinezkę możesz przesunąć.',
        cancel: 'Anuluj',
        add: 'Dodaj',
        close: 'Zamknij',
        addFavorite: 'Dodaj do ulubionych',
        removeFavorite: 'Usuń z ulubionych',
        pin: 'Przypnij',
        unpin: 'Odepnij',
        nearestOrder: 'Od najbliższego — Twoja kolejność zostaje',
        ownOrder: 'Twoja kolejność — przeciągnij, żeby zmienić',
        nearest: 'Najbliżej',
        noFilterMatch: 'Nic tu nie pasuje do filtra.',
        noPlaces: 'Nie masz jeszcze miejsc — wyszukaj je wyżej albo tapnij w mapę.',
        navigateTo: 'Nawiguj do {name}',
        addFavoriteNamed: 'Dodaj {name} do ulubionych',
        removeFavoriteNamed: 'Usuń {name} z ulubionych',
        pinNamed: 'Przypnij {name}',
        unpinNamed: 'Odepnij {name}',
        showOnMapNamed: 'Pokaż {name} na mapie',
    },
    lists: {
        title: 'Listy miejsc',
        count: '{n} lista | {n} listy | {n} list',
        newList: 'Nowa lista',
        addList: '+ Nowa lista',
        heading: 'LISTY MIEJSC',
        removeNamed: 'Usuń listę {name}',
        empty: 'Pogrupuj miejsca, np. „Jedzenie", „Auto", „Rodzina" — każda lista ma swój kolor pinezek na mapie.',
        withoutList: 'Bez listy: {n} miejsce. | Bez listy: {n} miejsca. | Bez listy: {n} miejsc.',
        dialogEdit: 'Lista miejsc',
        dialogNew: 'Nowa lista miejsc',
        removed: 'Lista usunięta — jej miejsca są teraz bez listy.',
        removeMessage: 'Miejsca z tej listy zostaną — trafią do „Bez listy”.',
        fields: {
            name: 'Nazwa',
            namePlaceholder: 'np. Jedzenie',
            color: 'Kolor pinezek',
        },
    },
    settings: {
        title: 'Ustawienia Miejsc',
        startView: 'WIDOK STARTOWY',
        startViewLabel: 'Widok startowy',
        mapHint: 'Wszystkie pinezki naraz',
        listHint: 'Twoja kolejność, w listach miejsc',
        mapFlash: 'Miejsca otworzą się na mapie.',
        listFlash: 'Miejsca otworzą się na liście.',
        toggleNote: 'Przełącznik Mapa/Lista w module zmienia widok tylko na teraz.',
    },
    dialog: {
        titleEdit: 'Miejsce',
        titleNew: 'Nowe miejsce',
        name: 'Nazwa',
        namePlaceholder: 'np. Parking pod biurem',
        point: 'Punkt na mapie',
        address: 'Adres',
        addressPlaceholder: 'Uzupełni się sam z punktu',
        list: 'Lista miejsc',
        favorite: 'Ulubione',
        favoriteHint: 'Lubię to miejsce',
        pinned: 'Przypięte',
        pinnedHint: 'Kafelek z nawigacją na górze modułu',
        pinnedFullHint: 'Przypiętych jest już {max} — odepnij któreś',
        pinnedLimit: 'Najwyżej {max} przypiętych miejsc.',
        note: 'Notatka',
        notePlaceholder: 'np. wjazd od podwórka, kod do bramy',
        pointHint: 'Przesuń pinezkę albo tapnij w mapę, żeby poprawić punkt.',
    },
    firstSteps: {
        place: {
            title: 'Pierwsze miejsce',
            action: 'Dodaj miejsce',
            what: 'Zapisz miejsce, do którego wracasz — wyszukaj je, tapnij w mapę albo użyj „Tu jestem".',
            why: 'Potem nawigujesz do niego jednym tapnięciem i wstawiasz je do wydarzenia bez szukania adresu.',
        },
        list: {
            title: 'Lista miejsc',
            action: 'Nowa lista',
            what: 'Grupa miejsc z kolorem, np. „Jedzenie" albo „Auto".',
            why: 'Na mapie od razu widać po kolorze, co jest czym, a filtr pokaże jedną listę.',
        },
        pinned: {
            title: 'Przypięte miejsce',
            action: 'Pokaż, jak',
            what: 'Przypnij miejsce, do którego jeździsz najczęściej — pinezką na liście albo w formularzu.',
            why: 'Trafi na kafelek na górze modułu: nawigacja jednym tapnięciem i pierwsza podpowiedź przy wydarzeniu.',
        },
    },
    help: {
        add: {
            title: 'Dodawanie miejsca',
            text: 'Szukaj po nazwie albo adresie, tapnij w mapę, użyj „Tu jestem" albo wklej link z Google Maps. Zawsze zobaczysz formularz z pinezką, którą da się przesunąć.',
            more: 'Link z „Udostępnij" w Google Maps wklejasz razem z nazwą — nazwa trafi do miejsca, a punkt z linku na mapę. Adres uzupełnia się sam z punktu.',
        },
        pinned: {
            title: 'Przypięte',
            text: 'Miejsca pod ręką: jedno tapnięcie uruchamia nawigację. Przy dodawaniu wydarzenia podpowiadają się jako pierwsze.',
            more: 'Przypiętych może być najwyżej 6. Przypnij miejsce pinezką na liście albo w jego formularzu.',
        },
        map: {
            title: 'Mapa i lista',
            text: 'Wszystkie miejsca — pinezki w kolorze swojej listy miejsc, ulubione z serduszkiem. Filtry nad mapą pokazują jedną listę albo same ulubione.',
            more: 'Przełącznik Mapa/Lista zmienia widok na teraz; ten, od którego moduł startuje, wybierzesz w Ustawieniach. Na liście „Najbliżej" sortuje chwilowo po odległości od Ciebie — Twoja kolejność zostaje.',
        },
        lists: {
            title: 'Listy miejsc',
            text: 'Grupy miejsc z własnym kolorem, np. „Jedzenie", „Auto", „Rodzina". Miejsce jest na jednej liście albo bez listy.',
            more: 'Kolejność list i miejsc w nich ustawiasz przeciąganiem. Usunięcie listy nie usuwa miejsc — trafiają do „Bez listy".',
        },
        favorites: {
            title: 'Ulubione',
            text: 'Serduszko przy miejscu, które lubisz. Ulubione da się odfiltrować, a na mapie mają wyróżnioną pinezkę. Może ich być dowolnie dużo.',
        },
        view: {
            title: 'Widok startowy',
            text: 'Czy Miejsca otwierają się na mapie, czy na liście. Ustawienie jest na koncie — działa tak samo na każdym urządzeniu.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Miejscach',
            description: 'Twoje miejsca na mapie: parking pod biurem, ulubiona pizzeria, mechanik. Zapisujesz raz, potem nawigujesz jednym tapnięciem i wstawiasz je do wydarzeń.',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy każdej sekcji wyjaśnia ją bez przewodnika.',
        },
    },
};
